/* ==========================================================================
   as-payment-terms.js
   "Learn more" on the Shop Pay Installments disclosure.

   The link already points at Shopify's own terms page, which is the
   destination Affirm names when a pop-up is not possible — so this file is an
   upgrade, never a dependency. If anything here fails, the click falls through
   to that href and the customer still reaches the full disclosure.

   WHAT IT UPGRADES TO. Shopify's <shopify-payment-terms> element opens the
   real Installments pop-up, with the live payment schedule for this price.
   That pop-up cannot be opened by any public API — the only way in is its own
   trigger, which lives in the element's shadow root. So the element is
   rendered beside the link, hidden, and its trigger is clicked.

   WHY THIS IS ALLOWED TO FAIL. A closed shadow root returns null, and the
   element's internals are Shopify's to change. Both cases are handled by
   simply not calling preventDefault, which lets the browser follow the link.
   Nothing is logged: a working fallback is not an error.
   ========================================================================== */

(function () {
  'use strict';

  function trigger(root) {
    var terms = root.querySelector('shopify-payment-terms');
    if (!terms) return null;

    /* Closed shadow roots return null, and so does an element that has not
       upgraded yet — both mean "no pop-up available", not "broken". */
    var shadow = terms.shadowRoot;
    if (!shadow) return null;

    return shadow.querySelector('button, a, [role="button"]');
  }

  function bind(scope) {
    (scope || document).querySelectorAll('[data-as-payterms-root]').forEach(function (root) {
      if (root.dataset.asPaytermsBound === '1') return;
      root.dataset.asPaytermsBound = '1';

      var link = root.querySelector('[data-as-payterms-link]');
      if (!link) return;

      link.addEventListener('click', function (event) {
        var target = trigger(root);
        if (!target) return; // fall through to the href

        event.preventDefault();
        target.click();
      });
    });
  }

  function start() {
    bind(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* The buy box is re-rendered on variant change, which replaces the
     disclosure and its terms element — the price changed, so the schedule in
     the pop-up has to change with it. */
  document.addEventListener('shopify:section:load', function (event) {
    bind(event.target);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      requestAnimationFrame(start);
    });
  }
})();
